var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-link',{staticClass:"button_",attrs:{"to":"/AggregatedMediaDashboard/Brand"}},[_vm._v("Aggregated Dashboard")]),_c('img',{staticClass:"componentImage",attrs:{"src":_vm.$loadImage(_vm.mediaCommsScreenshot)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }